module.exports = __webpack_public_path__ + "static/39FEA2_2_0-0b5b6b4acf08fc64254450184985be34.woff2";